import React from 'react';
import About from './components/About';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Testimonials from './components/Testimonials';
import Language from './components/Language';
import SocialFollow from './SocialFollow';
import './App.css';


 export default function App() {
  return (
    <main className="body text-gray-400 bg-gray-900 body-font">
      <Navbar />
      <About />
      <Projects />
      <Skills />
      <Language />
      <Testimonials />
      <Contact />
      <SocialFollow />
    </main>
  );
}


